import { CircularProgress, Stack } from '@mui/material';
import React from 'react';

const PermissionLoader = () => {
    return (
        <Stack sx={{ p: 3 }} alignItems="center" justifyContent="center">
            <CircularProgress size={32} />
        </Stack>
    );
};

export default PermissionLoader;
